import './js/common.js';
import './js/searchpanel.js';
import './js/searchform.js';
import './js/statsfilter.js';
import './js/multilevelmenu.js';
import './sass/style.scss';

(function ($) {
	$(document).ready(function () {
		console.log("SportData.it is ready");
	});
})(jQuery);